import React, { Component } from 'react';
import PropTypes from 'prop-types';

import branch from 'client/core/branch';

import ListingCard from 'client/components/ListingCard';

import { TOUR_SHOWING_APPLICATION_SOURCE_RECOMMENDED_LISTING } from 'common/tourConstants';

@branch({
  householdApplications: ['householdApplications'],
  currentUser: ['currentUser'],
  bookmarksByListingId: ['bookmarksByListingId'],
})
class SrRecommendedListings extends Component {
  static propTypes = {
    householdApplications: PropTypes.array,
    listingPhotoResolution: PropTypes.number.isRequired,
    currentUser: PropTypes.object.isRequired,
    bookmarksByListingId: PropTypes.object,
    listings: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  render() {
    const {
      bookmarksByListingId,
      householdApplications,
      listingPhotoResolution,
      listings,
      currentUser,
      isLoading,
    } = this.props;

    if (!listings || listings.length <= 2) {
      return null;
    }

    const householdApplicationStatusesByListingId = !householdApplications
      ? {}
      : householdApplications.reduce(
          (memo, { id, status }) => ({
            ...memo,
            [id]: status,
          }),
          {},
        );

    return (
      <div className="SrRecommendedListings">
        <span className="title">We Recommend</span>
        <div className="listingsContainer clearfix">
          {listings.map((listing) => (
            <ListingCard
              requestedFrom={TOUR_SHOWING_APPLICATION_SOURCE_RECOMMENDED_LISTING}
              enableBookmarkButton
              key={listing.id}
              listing={listing}
              isBookmarked={bookmarksByListingId ? !!bookmarksByListingId[listing.id] : false}
              onBookmarkClick={this._onBookmarkClick}
              currentUser={currentUser}
              applicationStatus={householdApplicationStatusesByListingId[listing.id]}
              photoResolution={listingPhotoResolution}
            />
          ))}
        </div>
        {isLoading && <div className="loading-gif clearfix" />}
      </div>
    );
  }
}

SrRecommendedListings.displayName = 'SrRecommendedListings';

export default SrRecommendedListings;
